import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { ParameterField } from './ParameterField';
import { GroupSection } from './PricingTableParts';
import { TierComposition } from './TierComposition';
export function LaborClinEditor({ clinPricing: clin, rateCard, onChange, kind }) {
    const columns = clin.columns.map((col)=>kind === 'T&M' && col.key === 'rate' ? {
            ...col,
            editable: true
        } : {
            ...col
        });
    if (!columns.some((c)=>c.key === 'ftes') && clin.volumeMethod.type === 'contractor_proposed' && clin.volumeMethod.hasFteColumn) columns.splice(1, 0, {
        key: 'ftes',
        label: 'FTEs',
        parameterName: 'ftes',
        editable: true,
        perPeriod: false
    });
    const locationVariants = clin.rateMethod.type === 'vehicle_schedule' ? clin.rateMethod.locationVariants : rateCard?.locationVariants;
    if ((kind === 'FFP' || kind === 'Generic') && locationVariants?.length && !columns.some((c)=>c.key === 'location')) columns.splice(1, 0, {
        key: 'location',
        label: 'Location',
        parameterName: 'location',
        editable: true,
        perPeriod: false
    });
    const labor = clin.laborStructure;
    const updateGroup = (index, group)=>{
        if (labor.type === 'direct' || labor.type === 'government_defined') onChange({
            ...clin,
            laborStructure: {
                ...labor,
                groups: labor.groups.map((g, i)=>i === index ? group : g)
            }
        });
        else if (labor.type === 'iteration_based') onChange({
            ...clin,
            laborStructure: {
                ...labor,
                laborBackup: group
            }
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraBadge, {
                children: clin.metadata.contractType || kind
            }),
            clin.metadata.periodName && /*#__PURE__*/ _jsx(SpecraBadge, {
                children: clin.metadata.periodName
            }),
            clin.metadata.isOptionalTask && /*#__PURE__*/ _jsx(SpecraBadge, {
                variant: "warning",
                children: "Optional"
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                children: kind === 'FFP' ? 'Fee embedded in price' : kind === 'T&M' ? 'Rate × Hours, no fee' : kind === 'CPFF' ? 'Cost + Fee' : ''
            }),
            clin.metadata.nteCeiling !== undefined && /*#__PURE__*/ _jsxs(SpecraText, {
                children: [
                    "NTE ",
                    clin.metadata.nteCeiling.toLocaleString()
                ]
            }),
            kind === 'CPFF' && clin.feeMethod.type === 'fixed_percentage' && /*#__PURE__*/ _jsx(ParameterField, {
                label: "Fee % (fraction)",
                param: clin.feeMethod.feePercent,
                editable: true,
                onChange: (value)=>{
                    if (clin.feeMethod.type === 'fixed_percentage') onChange({
                        ...clin,
                        feeMethod: {
                            ...clin.feeMethod,
                            feePercent: {
                                ...clin.feeMethod.feePercent,
                                value
                            }
                        }
                    });
                }
            }),
            (labor.type === 'direct' || labor.type === 'government_defined') && labor.groups.map((group, i)=>/*#__PURE__*/ _jsx(GroupSection, {
                    group: group,
                    columns: columns,
                    periods: clin.periods,
                    locationVariants: locationVariants,
                    onChange: (g)=>updateGroup(i, g)
                }, group.id)),
            labor.type === 'iteration_based' && /*#__PURE__*/ _jsx(GroupSection, {
                group: labor.laborBackup,
                columns: columns,
                periods: clin.periods,
                onChange: (g)=>updateGroup(0, g)
            }),
            labor.type === 'tiered' && labor.tiers.map((tier, i)=>/*#__PURE__*/ _jsx(TierComposition, {
                    tier: tier,
                    columns: columns,
                    periods: clin.periods,
                    rateCard: rateCard,
                    onChange: (next)=>onChange({
                            ...clin,
                            laborStructure: {
                                ...labor,
                                tiers: labor.tiers.map((t, index)=>i === index ? next : t)
                            }
                        })
                }, `${tier.tierNumber}-${i}`))
        ]
    });
}
